<template>
  <div>
    <van-checkbox v-model="r.value" shape="square">{{ r.label }}</van-checkbox>
  </div>
</template>
<style scoped>
.van-checkbox {
  height: 3rem;
  line-height: 3rem;
}
</style>
<script>
export default {
  props: {
    r: Object,
  },
  mounted() {},
  data() {
    return {};
  },
  methods: {},
};
</script>
